import { call, put, takeLatest } from "redux-saga/effects";
import apis from "services/transaction";
import transactionsSlice from ".";

const { actions } = transactionsSlice;

function* getTransactionsList(action) {
  try {
    const response = yield call(apis.listAndFilterTransactions, action.payload);

    yield put(actions.getTransactionsListSuccess(response));
  } catch (error) {
    yield put(
      actions.getTransactionsListError(
        error?.response?.data || "There was an error"
      )
    );
  }
}
function* getCryptoTransactionsList(action) {
  try {
    const response = yield call(apis.getCryptoTransactionsList, action.payload);

    yield put(actions.getCryptoTransactionsListSuccess(response));
  } catch (error) {
    yield put(
      actions.getCryptoTransactionsListError(
        error?.response?.data || "There was an error"
      )
    );
  }
}

function* getReversedTransactionsList(action) {
  try {
    const response = yield call(apis.listAndFilterTransactions, action.payload);
    yield put(actions.getReversedTransactionsListSuccess(response));
  } catch (error) {
    yield put(
      actions.getReversedTransactionsListError(
        error?.response?.data || "There was an error"
      )
    );
  }
}

function* getTransactionDetails(action) {
  try {
    const { data } = yield call(apis.getTransactionDetails, action.payload);

    yield put(actions.getTransactionDetailsSuccess(data));
  } catch (error) {
    yield put(
      actions.getTransactionDetailsError(
        error?.response?.data || "There was an error"
      )
    );
  }
}

function* getFiatPayinDetails(action) {
  try {
    const { data } = yield call(apis.getFiatPayinDetails, action.payload);
    yield put(actions.getFiatPayinDetailsSuccess(data));
  } catch (error) {
    yield put(actions.getFiatPayinDetailsError());
  }
}

function* searchTransactions(action) {
  try {
    const response = yield call(apis.searchTransactions, action.payload);
    yield put(actions.searchTransactionsSuccess(response));
  } catch (error) {
    yield put(actions.searchTransactionsError());
  }
}

function* search9PSBTransactions(action) {
  try {
    const response = yield call(apis.search9PSBTransactions, action.payload);
    yield put(actions.search9PSBTransactionsSuccess(response));
  } catch (error) {
    console.log("Search errror: ", error);
    yield put(actions.search9PSBTransactionsError());
  }
}

function* exportAccountTransactions(action) {
  try {
    const { payload, callbackFunc } = action.payload;
    const response = yield call(apis.exportAccountTransactions, payload);
    yield put(actions.exportAccountTransactionsSuccess(response));
    callbackFunc();
  } catch (error) {
    yield put(actions.exportAccountTransactionsError());
  }
}

export function* transactionsSaga() {
  yield takeLatest(actions.getTransactionsList.type, getTransactionsList);
  yield takeLatest(
    actions.getCryptoTransactionsList.type,
    getCryptoTransactionsList
  );
  yield takeLatest(
    actions.getReversedTransactionsList.type,
    getReversedTransactionsList
  );
  yield takeLatest(actions.search9PSBTransactions.type, search9PSBTransactions);
  yield takeLatest(actions.getTransactionDetails.type, getTransactionDetails);
  yield takeLatest(actions.getFiatPayinDetails.type, getFiatPayinDetails);
  yield takeLatest(actions.searchTransactions.type, searchTransactions);
  yield takeLatest(
    actions.exportAccountTransactions.type,
    exportAccountTransactions
  );
}
